<script context='module'>
  import { append, identical, reject } from 'ramda';
  import { getContext } from 'svelte';
  import { writable } from 'svelte/store';

  class Entry {
    constructor(context, element, { anchor, gravity }) {
      this.context = context;
      this.element = element;
      this.anchor = anchor;
      this.gravity = gravity;
      this.visible = writable(false);
    }

    show() {
      this.visible.set(true);
    }

    hide() {
      this.visible.set(false);
    }

    add() {
      this.assertContextIsPresent();
      this.context.update(append(this));
    }

    remove() {
      this.assertContextIsPresent();

      this.context.update(reject(identical(this)));
    }

    assertContextIsPresent() {
      if (this.context === undefined) {
        throw new Error('TooltipRoot context is unavailable. Did you forget to wrap your component in a TooltipRoot?');
      }
    }
  }

  const TOOLTIPS = Symbol('Tooltips');
  export const useTooltips = () => {
    const tooltips = getContext(TOOLTIPS);
    return (...args) => {
      const entry = new Entry(tooltips, ...args);
      entry.add();
      return entry;
    };
  };
</script>

<script>
  import TooltipContainer from './TooltipContainer.svelte';
  import Provider from '../Provider';

  const tooltips = writable([]);
</script>

<Provider key={TOOLTIPS} value={tooltips}>
  <slot />

  {#each $tooltips as tooltip (tooltip)}
    <TooltipContainer {tooltip} />
  {/each}
</Provider>
